var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveOne({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 2.625C0.75 1.58946 1.58947 0.75 2.625 0.75H15.375C16.4106 0.75 17.25 1.58947 17.25 2.625V15.375C17.25 16.4105 16.4106 17.25 15.375 17.25H2.625C1.58948 17.25 0.75 16.4105 0.75 15.375V2.625ZM13.5 2.25V8.24999C13.5 8.66421 13.1642 8.99999 12.75 8.99999H5.625C5.21079 8.99999 4.875 8.66421 4.875 8.24999V2.25H2.625C2.41789 2.25 2.25 2.41789 2.25 2.625V15.375C2.25 15.5821 2.41789 15.75 2.625 15.75H15.375C15.5821 15.75 15.75 15.5821 15.75 15.375V2.625C15.75 2.41788 15.5821 2.25 15.375 2.25H13.5ZM6.375 2.25V7.49999H12V2.25H6.375ZM10.125 3.37499C10.5392 3.37499 10.875 3.71078 10.875 4.12499V5.62499C10.875 6.03921 10.5392 6.37499 10.125 6.37499C9.71079 6.37499 9.375 6.03921 9.375 5.62499V4.12499C9.375 3.71078 9.71079 3.37499 10.125 3.37499Z",
    fill: "#40A0C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveOne);
export default __webpack_public_path__ + "static/media/save-one.9bb972a1b8b31c5d3fd678479c32fda1.svg";
export { ForwardRef as ReactComponent };